export const boxPosition = ['inBox', 'outOfBox']
export const compete = ['haveCompete', 'noCompete']
export const completeStatus = ['complete', 'inComplete']